'use strict';

import { carerDetails } from '../../_modules/carer-detail/carer-detail';

export default class SummaryDashboard {
  	constructor() {

		let $nav = $('.multi-steps-nav'),
			$summary = $('.summary-dashboard'),
			$summaryRight = $('.summary-dashboard--right'),
			$summaryOrder = $('.summary-order'),
			$summaryOrderSticky = $('.summary-order--sticky');

		let $navHeight,
			$summaryHeight,
			$summaryStickyHeight,
			$summaryOrderHeight;

		// define summary style
		$navHeight = $nav.height();
		$summaryHeight = $(window).height() - $navHeight;

		$summaryStickyHeight = $summaryOrderSticky.height();
		$summaryOrderHeight = $summaryHeight - $summaryStickyHeight;

		$summary.css('height', $summaryHeight);
		$summaryRight.css('height', $summaryHeight);
		$summaryOrder.css('height', $summaryOrderHeight);

		$('.summary-order').mCustomScrollbar({
			setTop: 0,
			theme: 'minimal-dark',
			scrollbarPosition: 'outside'
			// SET SCROLLABALE
		});

		$('.js-edit-section').on('click', function (e) {
			e.preventDefault();

			let $offsetHeight = $('.multi-steps-nav').height();

			$('.js-display-summary').trigger('click');

			$('html, body').animate({
				scrollTop: $( $.attr(this, 'href') ).offset().top - $offsetHeight
			}, 1000);

		});

		$('.js-continue-dashboard').on('click', function (e){
			$('.summary-dashboard').slideToggle();
		});
  	}

  	getCarerDetailSummary(){
  		let _carersList = carerDetails(),
  			fullName,
  			_values = {};

  		$.each(_carersList, function(index, carer){
  			fullName = carer.FirstName + ' ' + carer.LastName;

  			_values[index] = fullName;
  		});

		return _values;
  	}

  	getContactDetailsSummary(){
  		let $doNotCall = $('#IsDoNotCallOpted'),
  			$primaryNumber = $('#PrimaryNumber'),
  			$secondaryNumber = $('#SecondaryNumber'),
    		$emailAddress = $('#EmailAddress'),
    		doNotCallLabel = 'Do not call except in response to Client in bound call',
    		$patientHaveCarer = $('#PatientHaveCarer'),
    		$primaryContact = $('#PrimaryContact'),
    		primaryContactLabel = 'First carer is the primary contact person',
			_values;

  		_values = {
  			'DoNotCall': $doNotCall.prop('checked') ? doNotCallLabel : null,
			'PhoneNumber': $primaryNumber.val(),
        	'SecondaryNumber': $secondaryNumber.val() == '' ? null : $secondaryNumber.val(),
        	'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
        	'PrimaryContact': $primaryContact.prop('checked') ? primaryContactLabel : null
		};

		return _values;
  	};

  	getDeliveryDetailsSummary(){
	    let $deliveryInputs = $('#delivery-details .floating-input'),
	    	deliveryNotes = $('#DeliveryNotes').val() != '' ? $('#DeliveryNotes option:selected').text() : '',
	    	additionalNotes = $('#AdditionalAddressNotes').val(),
	    	deliveryState = $('#administrative_area_level_1').val(),
        allOrdersFree = $('#AllOrdersFree'),
	    	_deliveryDetails = {},
  			_values = {};

        let deliveryNotesAll = deliveryNotes += ', ' + additionalNotes;
        if(allOrdersFree.prop('checked')){
          deliveryNotesAll += ', ' + $("label[for='AllOrdersFree']").text();
        }

  		$deliveryInputs.each(function(){

  			let $this = $(this);

  			_deliveryDetails[$this.get(0).id] = $this.val();
  		});

  		let deliveryAddress = _deliveryDetails.street_number + ', ' + _deliveryDetails.route +
  							  _deliveryDetails.locality + ', ' + _deliveryDetails.postal_code + ', '+ deliveryState;

  		_values ={
  			'DeliveryAddress' : deliveryAddress,
  			'DeliveryNotes' : deliveryNotesAll
  		}

	    return _values;
	}

  	getPatientDetailsSummary(){
		let $title = $('#Title'),
			$firstName = $('#FirstName'),
			$lastName = $('#LastName'),
			$dobDay = $('#DobDay'),
			$dobMonth = $('#DobMonth'),
			$dobYear = $('#DobYear'),
			$gender = $('#Gender'),
			$clientUR = $('#ClientUR'),
			_values;

		_values = {
			'FullName' : $title.val() + ' ' + $firstName.val() + ' '+ $lastName.val(),
			'Dob' : $dobDay.val() + ' - ' + $dobMonth.val() + ' - ' + $dobYear.val(),
			'Gender': $gender.val(),
			'ClientUR': $clientUR.val()
		};

		return _values;
  	};

  	getRegimenStartDate(){
  		let _values,
  			$startToday = $('#StartToday'),
  			$startDateInput = $('#StartDate'),
  			startDate;

  		if($startToday.prop('checked'))
  			startDate = 'Start Immediately';
  		else
  			startDate = $startDateInput.val();

  		_values ={
  			'StartDate' : startDate
  		};

  		return _values;
  	};

  	getRegimenNotes(){
  		let _regimenNotes = $('#regimen-products').find('textarea'),
  			_values = {};

  		$.each(_regimenNotes, function(index, notes){

  			_values[index] = $(this).val();
  		});

		return _values;
  	};

  	displaySummary(section){

  		let $el,
  			_values;

  		switch(section){
  			case 'patient':
  				$el = $('.summary--patient-details');
  				_values = this.getPatientDetailsSummary();
  				this.setSummaryValues($el, _values)
  				break;
  			case 'contact-details':
  				$el = $('.summary--contact-details');
  				_values = this.getContactDetailsSummary();
  				this.setSummaryValues($el, _values)
  				break;
  			case 'carer-details':
  				$el = $('.summary--carer-details');
  				_values = this.getCarerDetailSummary();
  				this.setSummaryValues($el, _values)
  				break;
  			case 'regimen-date':
  				$el = $('.summary--regimen-date');
  				_values = this.getRegimenStartDate();
  				this.setSummaryValues($el, _values)
  				break;
  			case 'regimen-notes':
  				$el = $('.summary--regimen-notes');
  				_values = this.getRegimenNotes();
  				this.setSummaryValues($el, _values)
  				break;
  			case 'products':
  				$el = $('.summary--products-details');
  				break;
  			case 'delivery':
  				$el = $('.summary--delivery-details');
  				_values = this.getDeliveryDetailsSummary();
  				this.setSummaryValues($el, _values)
  				break;
  			default:
            	return false;
  		}

  		$el.fadeIn({
	        duration: 500,
	        easing: 'easeOutExpo',
	        queue: false
	    });

  	};

  	setSummaryValues($el, _values){
  		let $summaryContent = $el.find('.summary-dashboard__cell-content');

  		//remove previous values
  		$summaryContent.html('');

  		$.each(_values, function(key, item){

  			if(item != null)
				$summaryContent.append('<span>'+ item + '</span>');
  		});
  	};
}
